// extracted by mini-css-extract-plugin
module.exports = {"heading":"index-module--heading--3q_in","divider":"index-module--divider--2piwF"};